/**
 * SustainedMassPassiveSkillEffect — Astral dense-path upgrade: extended
 * Dense window and gravity wake duration.
 *
 * Code-only passive. When this node unlocks, its effect values
 * (`durationMs: 2000`, `gravityWakeDurationMs: 300`) become visible to the
 * resolver. The actual duration logic lives in DenseSkillEffect:
 * - `activate()` queries `resolver.getAdditiveEffect('dense', 'durationMs')`
 *   to extend the 5000ms base window to 7000ms.
 * - `_onTeleport()` queries `resolver.getAdditiveEffect('dense', 'gravityWakeDurationMs')`
 *   to extend the 500ms base wake to 800ms.
 *
 * This class carries no runtime behavior — it is a pure marker that the
 * node is unlocked. The tree JSON provides the effect values; the resolver
 * aggregates them; Dense/Collapse consumes them.
 *
 * Pure logic — no Phaser dependencies.
 *
 * @see astral-spec.md § dense_duration
 * @see ADR-064 (attunement shared systems architecture)
 */

import type { SkillEffect } from '../../SkillEffect.js';

// ---------------------------------------------------------------------------
// Skill effect
// ---------------------------------------------------------------------------

export class SustainedMassPassiveSkillEffect implements SkillEffect {
  readonly skillId = 'dense_duration';
  readonly type = 'passive' as const;
  readonly activationMode = 'instant' as const;

  // --- SkillEffect interface ---

  activate(): boolean { return false; }
  isActive(): boolean { return false; }
  update(_delta: number): void { /* passive — nothing to tick */ }
  destroy(): void { /* no-op marker passive */ }
}
